import { isObject } from "lodash";

export const hasSomeTruthyValues = value => {
  if (isObject(value)) {
    return Object.values(value).some(value => hasSomeTruthyValues(value));
  }

  return Boolean(value);
};
